import React from 'react';

import PropTypes from 'prop-types';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

import S from '../styles';

const defaultMaskOptions = {
  prefix: '',
  suffix: ' %',
  includeThousandsSeparator: false,
  allowDecimal: true,
  decimalSymbol: ',',
  decimalLimit: 2,
  integerLimit: 3,
  allowNegative: false,
  allowLeadingZeroes: false,
};

function InputPercent({ maskOptions, value, ...inputProps }) {
  const mask = createNumberMask({
    ...defaultMaskOptions,
    ...maskOptions,
  });

  if (value) {
    return <S.Input mask={mask} defaultValue={String(value).replace('.', ',')} {...inputProps} />;
  }
  return <S.Input mask={false} {...inputProps} />;
}

InputPercent.defaultProps = {
  inputMode: 'numeric',
  maskOptions: {},
  value: '',
};

InputPercent.propTypes = {
  inputMode: PropTypes.string,
  maskOptions: PropTypes.shape({
    prefix: PropTypes.string,
    suffix: PropTypes.string,
    includeThousandsSeparator: PropTypes.bool,
    thousandsSeparatorSymbol: PropTypes.string,
    allowDecimal: PropTypes.bool,
    decimalSymbol: PropTypes.string,
    decimalLimit: PropTypes.string,
    requireDecimal: PropTypes.bool,
    allowNegative: PropTypes.bool,
    allowLeadingZeroes: PropTypes.bool,
    integerLimit: PropTypes.number,
  }),
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default InputPercent;
